import { type FC } from 'react';
import { Icon } from '@lingoda/monolith-graphql';
import {
    CalendarStarIcon,
    CheckCircleIcon,
    GiftIcon,
    MoneyIcon,
    StudentIcon,
    TagIcon,
} from '@lingoda/ui/icons/lingodaIcons';
import { SectionIcons } from '@lingoda/ui/icons/SectionIcons';

interface Props {
    icon: Icon;
}

const sectionIconMap = {
    [Icon.SectionDe]: 'german',
    [Icon.SectionEn]: 'english',
    [Icon.SectionEs]: 'spanish',
    [Icon.SectionFr]: 'french',
    [Icon.SectionIt]: 'italian',
};

const CheckCircleIconDefault = () => <CheckCircleIcon size={24} />;

const GiftIconDefault = () => <GiftIcon size={24} data-cy="content-block-icon-heart" />;
const TagIconDefault = () => <TagIcon size={24} data-cy="content-block-icon-pricetag" />;
const CalendarStarIconDefault = () => (
    <CalendarStarIcon size={24} data-cy="content-block-icon-trial" />
);
const StudentIconDefault = () => (
    <StudentIcon size={24} data-cy="content-block-icon-study-calendar" />
);
const MoneyIconDefault = () => <MoneyIcon size={24} data-cy="content-block-icon-pay-in-rates" />;

const ContentBlockIcon = ({ icon }: Props) => {
    let IconComponent: FC = CheckCircleIconDefault;
    switch (icon) {
        case Icon.Heart:
            IconComponent = GiftIconDefault;
            break;
        case Icon.Pricetag:
            IconComponent = TagIconDefault;
            break;
        case Icon.Trial:
            IconComponent = CalendarStarIconDefault;
            break;
        case Icon.StudyCalendar:
            IconComponent = StudentIconDefault;
            break;
        case Icon.PayInRates:
            IconComponent = MoneyIconDefault;
            break;
        case Icon.SectionEn:
        case Icon.SectionEs:
        case Icon.SectionDe:
        case Icon.SectionFr:
        case Icon.SectionIt:
            IconComponent = SectionIcons[sectionIconMap[icon]];
            break;
        default:
            break;
    }

    return <IconComponent />;
};

export default ContentBlockIcon;
